import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  Lecturers: {
    id: 'label_lecturers',
    defaultMessage: 'Lecturers / Avatar',
  },
  LecturersHelp: {
    id: 'help_lecturers',
    defaultMessage: 'Uses lecturers set on content if not set here.',
  },
  ShowAll: {
    id: 'lecturers_show_all',
    defaultMessage: 'Show all',
  },
  Close: {
    id: 'lecturers_close',
    defaultMessage: 'Close',
  },
  RandomSort: {
    id: 'label_lecturers_random_sort',
    defaultMessage: 'Random sort',
  },
  RandomSortHelp: {
    id: 'help_lecturers_random_sort',
    defaultMessage:
      'If not selected, the defined sort order of the entries is used.',
  },
});
